import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenses2Icon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 2.7207V7.7207H20",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 2.28027,
			width: 16,
			height: 19.4401,
			rx: 4,
			stroke: "#FFB3B3",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 16.2207H8",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 12.2207H8",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 8.2207H8",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExpenses2Icon;
